import React from "react";
import styled from "styled-components";
import { ReactComponent as CheckIcon } from "assets/svg/check-filled.svg";

interface Props {
  isSelected: boolean;
  onClick: () => void;
  image: React.ReactNode;
  title: string;
  subtitle?: string;
}

export const PublishOption = ({
  isSelected,
  image,
  title,
  subtitle,
  onClick,
}) => {
  return (
    <Container
      style={{ borderColor: isSelected ? "var(--main-color)" : "#d9d9d9" }}
      onClick={onClick}
    >
      <Grid>
        <Image>{image}</Image>
        <Content>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Content>
      </Grid>
      {isSelected && <StyledCheckIcon />}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  border-radius: 10px;
  border: 2px solid;
  background: linear-gradient(49deg, #f2f5f7 21.77%, #fff 82.64%);
  cursor: pointer;
`;

const Grid = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;

  ${({ theme }) => theme.media.mobile} {
    gap: 2px;
  }
`;

const Image = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  flex-shrink: 0;

  ${({ theme }) => theme.media.mobile} {
    width: 60px;
    height: 60px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: var(--main-color);

  ${({ theme }) => theme.media.mobile} {
    font-size: 14px;
  }
`;

const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: var(--tertiary-text-color);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  ${({ theme }) => theme.media.mobile} {
    font-size: 12px;
  }
`;

const StyledCheckIcon = styled(CheckIcon)`
  position: absolute;
  width: 27px;
  height: 27px;
  top: -10px;
  right: -10px;
  color: var(--main-color);
  border: 1px solid white;
  border-radius: 50%;

  ${({ theme }) => theme.media.mobile} {
    width: 24px;
    height: 24px;
  }
`;
